import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export interface EmailVerificationStatusSyncResult {
  success: boolean;
  profileState: 'updated' | 'already-synced';
  profileStatus: 'pending_verification' | 'active';
}

const syncEmailVerificationStatusCallable = httpsCallable<
  undefined,
  EmailVerificationStatusSyncResult
>(functions, 'syncEmailVerificationStatus');

export const syncEmailVerificationStatus = async (): Promise<EmailVerificationStatusSyncResult> => {
  const result = await syncEmailVerificationStatusCallable();
  return result.data;
};
